import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  justify-content: space-between;
  width: auto;

  button {
    display: flex;
    width: auto;
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: auto;
    }

    svg {
      width: auto;
      margin-right: 0;
    }
  }

  span {
    width: 50px;
    display: inline-flex;
    justify-content: center;
  }
`;
